import * as React from "react";
import * as moment from "moment";
import { observer } from "mobx-react";
import { AppStore } from "../../stores/AppStore";
import { observable } from "mobx";
import { Alert, Alignment, Button, Classes, Dialog, FormGroup, HTMLSelect, Icon, InputGroup, Switch, Tag } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { IEmpresa, newEmpresa } from "../../model";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { toast } from "react-toastify";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { formatCnpj, sortBy } from "../../utils";
import { ParcelamentosStore } from "../../stores/parcelamentos/ParcelamentosStore";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";
import { PagamentosMultiselect } from "../utils/PagamentosMultiselect";
import { AppIcon } from '../utils/AppIcon';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ptBR } from "@mui/x-date-pickers/locales";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { debounce } from "underscore";
import InfoModal from "../info-modal/InfoModal";
import Cookies from 'universal-cookie';

const cookies = new Cookies()
const numeral = require("numeral");

/**
* Componente principal da página de CNDS.
* 
* Este componente gerencia a exibição e manipulação de dados relacionados à CNDS,
* incluindo agendamentos, tarefas e interações do usuário.
*/

@observer
export default class ParcelamentosPage extends React.Component {

  /**
 * Observável que contém os estados e dados utilizados na página.
 */
  obs = observable({
    tarefas_page: 1 as number,
    parcelas_page: 1 as number,
    parcelamentos_page: 1 as number,
    selectEmpresa: newEmpresa() as IEmpresa,
    selectEmpresaSolicitacao: newEmpresa() as IEmpresa,
    erros: "" as string,
    view_parcelamentos: false as boolean,
    view_parcelas: false as boolean,
    tipoSubParcela: "" as string,
    open_edit_task_parcelamento: false as boolean,
    status: "" as string,
    tipo: "todos" as string,
    tributo: "" as string,
    tipoParcela: 0 as number,
    showPGFN: false,
    showReceita: false,
    showEspeciais: false,
    showSimples: false,
    list: [] as string[],
    itens_simplificado: [] as string[],
    itens_nao_previdenciario: [] as string[],
    lei_12996: [] as string[],
    lei_11941: [] as string[],
    previdenciario_inss: [] as string[],
    previdenciario_pert: [] as string[],
    especiais: [] as string[],
    pgfn: [] as string[],
    filter_referencia: "" as string,
    task_id: "" as string,
    tipoPrincipalEdicao: null,
    edit_row: {} as any,
    n_parcelamento: "" as string,
    dataEntrada: [] as string[],
    fetchOptions: {} as any,
    fetchReferencia: {} as any,
    dia_agendamento: 10 as number,
    open_ajuda: false as boolean,
    filter_status: "" as string,
    filter_status_parcelas: "" as string,
    filter_situacao: "" as string,
    showSefa: false,
    sefa_prorefis: [] as string[],
    sefa_acompanhar: [] as string[],
    parcsn: [] as string[],
    parcsn_esp: [] as string[],
    pertsn: [] as string[],
    relpsn: [] as string[],
    parcmei: [] as string[],
    parcmei_esp: [] as string[],
    pertmei: [] as string[],
    relpmei: [] as string[],

  })

  constructor(props) {
    super(props);
    this.obs.fetchOptions = debounce(this.handleBuscaTarefasFilter.bind(this), 800);
    this.obs.fetchReferencia = debounce((filter) => { ParcelamentosStore.handleTasksPagedParcelamentos(1, this.obs.task_id, filter, this.obs.filter_status); }, 800);
  }

  /**
 * Método do ciclo de vida do React chamado após o componente ser montado.
 */
  async componentDidMount() {

    AppStore.setTitle("Parcelamentos");

    ParcelamentosStore.resetUI();

    this.resetPageState();

  }

  /**
  * Função apra resetar a busca prévia na página de /parcelamentos.
  */

  resetPageState = () => {
    this.obs.tarefas_page = 1;
    this.obs.parcelas_page = 1;
    this.obs.parcelamentos_page = 1;

    this.obs.selectEmpresa = newEmpresa();
    this.obs.filter_situacao = "";
    this.obs.tipoParcela = 0;
    this.obs.tipoSubParcela = "";

    this.obs.task_id = "";
    this.obs.filter_referencia = "";
    this.obs.filter_status = "";
    this.obs.filter_status_parcelas = "";

    this.obs.view_parcelamentos = false;
    this.obs.view_parcelas = false;
    this.obs.erros = "";
    this.obs.edit_row = {};
    this.obs.n_parcelamento = "";
    this.obs.tributo = "";
  };

  /**
   * Finaliza a solicitação de parcelamentos com base nos dados informados pelo usuário.
   * 
   * Esta função realiza diversas validações antes de montar o payload da solicitação:
   * - Verifica se uma empresa foi selecionada.
   * - Valida se ao menos uma subcategoria da Receita Federal foi selecionada, caso aplicável.
   * - Valida se ao menos uma subcategoria de Especiais foi selecionada, caso aplicável.
   * - Verifica se um e-mail foi informado caso o envio por e-mail esteja ativado.
   * 
   * Após as validações, a função:
   * - Monta um objeto de parâmetros (`params`) contendo os dados estruturados por tipo de parcelamento: PGFN, Receita Federal e Especiais.
   * - Atualiza o estado da interface, fechando o modal de solicitação.
   * - Envia os dados para a função `ParcelamentosStore.handleSolicitaParcelamentos`, que realiza a requisição.
   * - Atualiza a lista de tarefas de parcelamento chamando `ParcelamentosStore.handleTasksPaged`.
   * - Reseta os dados do modal de solicitação.
   * 
   * @returns {Promise<void>} Uma promise que resolve após a conclusão da solicitação e atualização da interface.
  */

  handleConcluirSolicitacao = async () => {

    if (!this.obs.selectEmpresaSolicitacao?.cnpj) {
      toast.error("Selecione uma empresa!", {});
      return;
    }

    if (this.obs.showReceita) {
      const hasSimplificado = this.obs.list.includes("2.1");
      const hasNaoPrevidenciario = this.obs.list.includes("2.2");

      if (!hasSimplificado && !hasNaoPrevidenciario) {
        toast.error("Selecione pelo menos uma subcategoria da Receita Federal!", {});
        return;
      }

    }

    if (this.obs.showEspeciais) {
      const categoriasEspeciais = ["3.1", "3.2", "3.3", "3.4", "3.5"];
      const marcadas = this.obs.list.filter((item) => categoriasEspeciais.includes(item));

      if (marcadas.length === 0) {
        toast.error("Selecione pelo menos uma subcategoria de Especiais!", {});
        return;
      }
    }

    if (this.obs.showSimples) {
      const categoriasSimples = ["4.1", "4.2", "4.3", "4.4", "4.5", "4.6", "4.7", "4.8"];
      const marcadas = this.obs.list.filter((item) => categoriasSimples.includes(item));

      if (marcadas.length === 0) {
        toast.error("Selecione pelo menos uma subcategoria do Simples Nacional!", {});
        return;
      }
    }

    if (this.obs.showSefa) {
      const hasProrefis = this.obs.list.includes("5.1");
      const hasAcompanhar = this.obs.list.includes("5.2");

      if (!hasProrefis && !hasAcompanhar) {
        toast.error("Selecione pelo menos uma subcategoria da SEFA!", {});
        return;
      }

      if (hasProrefis && !this.obs.sefa_prorefis.length) {
        toast.error("É necessário preencher pelo menos um número de parcelamento na subcategoria da PROREFIS!", {});
        return;
      }

    }

    let params = {
      cnpj: this.obs.selectEmpresaSolicitacao.cnpj,
      dia_agendamento: this.obs.dia_agendamento,
      pgfn: [{
        n_parcelamentos: this.obs.pgfn,
        tipo_p: 1,
        tipo_s: null,
        ativo: this.obs.showPGFN
      }],
      receita: [{
        n_parcelamentos: this.obs.itens_simplificado,
        tipo_p: 2,
        tipo_s: "2.1",
        ativo: this.obs.showReceita ? this.obs.list.includes("2.1") : false
      },
      {
        n_parcelamentos: this.obs.itens_nao_previdenciario,
        tipo_p: 2,
        tipo_s: "2.2",
        ativo: this.obs.showReceita ? this.obs.list.includes("2.2") : false
      }],
      especiais: [
        {
          n_parcelamentos: this.obs.lei_12996,
          tipo_p: 3,
          tipo_s: "3.1",
          ativo: this.obs.showEspeciais ? this.obs.list.includes("3.1") : false
        },
        {
          n_parcelamentos: this.obs.lei_11941,
          tipo_p: 3,
          tipo_s: "3.2",
          ativo: this.obs.showEspeciais ? this.obs.list.includes("3.2") : false
        },
        {
          n_parcelamentos: this.obs.previdenciario_inss,
          tipo_p: 3,
          tipo_s: "3.3",
          ativo: this.obs.showEspeciais ? this.obs.list.includes("3.3") : false
        },
        {
          n_parcelamentos: this.obs.previdenciario_pert,
          tipo_p: 3,
          tipo_s: "3.4",
          ativo: this.obs.showEspeciais ? this.obs.list.includes("3.4") : false
        },
        {
          n_parcelamentos: this.obs.especiais,
          tipo_p: 3,
          tipo_s: "3.5",
          ativo: this.obs.showEspeciais ? this.obs.list.includes("3.5") : false
        }
      ],
      simples: [{
        n_parcelamentos: this.obs.parcsn,
        tipo_p: 4,
        tipo_s: "4.1",
        ativo: this.obs.showSimples ? this.obs.list.includes("4.1") : false
      },
      {
        n_parcelamentos: this.obs.parcsn_esp,
        tipo_p: 4,
        tipo_s: "4.2",
        ativo: this.obs.showSimples ? this.obs.list.includes("4.2") : false
      },
      {
        n_parcelamentos: this.obs.pertsn,
        tipo_p: 4,
        tipo_s: "4.3",
        ativo: this.obs.showSimples ? this.obs.list.includes("4.3") : false
      },
      {
        n_parcelamentos: this.obs.relpsn,
        tipo_p: 4,
        tipo_s: "4.4",
        ativo: this.obs.showSimples ? this.obs.list.includes("4.4") : false
      },
      {
        n_parcelamentos: this.obs.parcmei,
        tipo_p: 4,
        tipo_s: "4.5",
        ativo: this.obs.showSimples ? this.obs.list.includes("4.5") : false
      },
      {
        n_parcelamentos: this.obs.parcmei_esp,
        tipo_p: 4,
        tipo_s: "4.6",
        ativo: this.obs.showSimples ? this.obs.list.includes("4.6") : false
      },
      {
        n_parcelamentos: this.obs.pertmei,
        tipo_p: 4,
        tipo_s: "4.7",
        ativo: this.obs.showSimples ? this.obs.list.includes("4.7") : false
      },
      {
        n_parcelamentos: this.obs.relpmei,
        tipo_p: 4,
        tipo_s: "4.8",
        ativo: this.obs.showSimples ? this.obs.list.includes("4.8") : false
      }],
      sefa: [{
        n_parcelamentos: this.obs.sefa_prorefis,
        tipo_p: 5,
        tipo_s: "5.1",
        ativo: this.obs.showSefa ? this.obs.list.includes("5.1") : false
      },
      {
        n_parcelamentos: this.obs.sefa_acompanhar,
        tipo_p: 5,
        tipo_s: "5.2",
        ativo: this.obs.showSefa ? this.obs.list.includes("5.2") : false
      }],
    }

    ParcelamentosStore.obs.open_solicitar = false;

    await ParcelamentosStore.handleSolicitaParcelamentos(params)

    this.obs.selectEmpresa = newEmpresa();
    this.obs.tarefas_page = 1
    this.obs.filter_situacao = ""
    this.obs.tipoParcela = 0
    this.obs.tipoSubParcela = ""

    await ParcelamentosStore.handleTasksPaged(1, "", "", 0, "");

    this.resetSolicitacaoModal();

  };

  tiposBloquearNumeroEdicao = [
    "3.1",
    "4.1",
    "4.2",
    "4.3",
    "4.4",
    "4.5",
    "4.6",
    "4.7",
    "4.8"
  ];

  /**
   * Alterna a seleção de uma categoria na lista de opções marcadas.
   * 
   * Esta função verifica se a `categoria` fornecida já está presente na lista `obs.list`.
   * - Se a categoria **não estiver presente**, ela será **adicionada** à lista.
   * - Se a categoria **já estiver presente**, ela será **removida** da lista.
   * 
   * Útil para componentes de checkbox ou múltipla seleção de filtros.
   * 
   * @param {string} categoria Código da categoria a ser adicionada ou removida da lista.
  */


  handleCheckChange = (categoria: string) => {
    const index = this.obs.list.indexOf(categoria);

    if (index < 0) {
      this.obs.list.push(categoria);
    } else {
      this.obs.list.splice(index, 1);
    }
  };

  /**
 * Realiza a busca de tarefas de forma paginada com base no número da página fornecido.
 * 
 * @param {number} page - Número da página a ser carregada.
 * 
 * Este método atualiza o estado atual da página (`this.obs.tarefas_page`). 
 * 
 * Em seguida, chama o método `handleTasksPaged` para buscar as tarefas correspondentes à página e à empresa selecionada.
 */
  handleBuscaTarefasPaged = async (page: number) => {

    this.obs.tarefas_page = page

    await ParcelamentosStore.handleTasksPaged(page, this.obs.selectEmpresa.cnpj, this.obs.filter_situacao, this.obs.tipoParcela, this.obs.tipoSubParcela);

  };

  /**
   * Realiza a busca paginada de parcelamentos vinculados a uma tarefa específica.
   * 
   * Esta função:
   * - Atualiza o número da página atual (`parcelamentos_page`) observada.
   * - Chama o método `ParcelamentosStore.handleTasksPagedParcelamentos` para buscar os dados da página especificada,
   *   utilizando também o `task_id` e o filtro de referência (`filter_referencia`) atualmente selecionados.
   * 
   * É utilizada em componentes com paginação.
   * 
   * @param {number} page Número da página a ser buscada.
   * @returns {Promise<void>} Uma promise que resolve após o carregamento dos dados da nova página.
  */

  handleBuscaParcelamentosPaged = async (page: number) => {

    this.obs.parcelamentos_page = page;

    await ParcelamentosStore.handleTasksPagedParcelamentos(page, this.obs.task_id, this.obs.filter_referencia, this.obs.filter_status);
  };

  /**
   * Realiza a busca paginada das parcelas de um parcelamento específico.
   * 
   * Esta função:
   * - Atualiza o número da página atual de parcelas (`parcelas_page`) observada.
   * - Ativa o estado de loading (`loading_parcelas`) enquanto os dados estão sendo carregados.
   * - Chama `ParcelamentosStore.handleTasksPagedParcelas` para buscar as parcelas com base nos filtros:
   *   - `task_id`: ID da tarefa selecionada.
   *   - `tributo`: Tipo de tributo vinculado.
   *   - `n_parcelamento`: Número do parcelamento.
   *   - `periodoEntrada`: Intervalo de datas utilizado como filtro de vencimento.
   * - Após a resposta, desativa o estado de loading.
   * 
   * É utilizada para navegar entre páginas de parcelas em uma interface paginada.
   * 
   * @param {number} page Número da página de parcelas a ser carregada.
   * @returns {Promise<void>} Uma promise que resolve após o carregamento das parcelas.
  */

  handleBuscaParcelasPaged = async (page: number) => {

    this.obs.parcelas_page = page

    ParcelamentosStore.obs.loading_parcelas = true

    await ParcelamentosStore.handleTasksPagedParcelas(page, this.obs.task_id, this.obs.tributo, this.obs.n_parcelamento, ParcelamentosStore.obs.periodoEntrada, this.obs.filter_status_parcelas);

    ParcelamentosStore.obs.loading_parcelas = false

  };

  /**
   * Fecha o modal de edição de tarefa de parcelamento e limpa o tipo principal selecionado.
   * 
   * Esta função:
   * - Define `open_edit_task_parcelamento` como `false`, ocultando o modal de edição da tarefa.
   * - Reseta o valor de `tipoPrincipalEdicao` para `null`, limpando o estado relacionado ao tipo principal da tarefa que estava em edição.
   * 
   * É chamada quando o usuário cancela ou conclui a edição de uma tarefa de parcelamento.
   * 
   * @returns {Promise<void>} Uma promise que resolve imediatamente após atualizar os estados observados.
  */

  handleCloseEditTarefa = async () => {

    this.obs.open_edit_task_parcelamento = false;
    this.obs.tipoPrincipalEdicao = null;

  }

  /**
   * Formata e exibe o CNPJ de uma empresa junto com a razão social, para exibição em tabelas.
   * 
   * Esta função:
   * - Recebe uma célula e uma linha de dados (geralmente em um componente de tabela).
   * - Busca a empresa correspondente ao CNPJ presente na linha, utilizando `EmpresaStore.getByCnpj`.
   * - Se a empresa for encontrada, retorna uma string com:
   *   - A razão social (limitada aos primeiros 30 caracteres).
   *   - O CNPJ formatado (ex: 00.000.000/0000-00).
   * - Caso não exista CNPJ ou a empresa não seja encontrada, retorna uma string vazia.
   * 
   * @param {*} cell Valor da célula atual (não utilizado diretamente nesta função).
   * @param {Object} row Objeto da linha contendo os dados da empresa, incluindo o campo `cnpj`.
   * @returns {string} String formatada com razão social e CNPJ, ou string vazia se não aplicável.
  */

  cnpjFormatter(cell, row) {

    if (row.cnpj) {
      let emp = EmpresaStore.getByCnpj(row.cnpj);
      if (emp) {
        return `${emp.razao_social.substring(0, 30)} - ${formatCnpj(row.cnpj)}`
      }
    }
    return ""

  };

  /**
   * Retorna a razão social da empresa com base no CNPJ informado.
   * 
   * Esta função:
   * - Verifica se o CNPJ foi informado.
   * - Utiliza `EmpresaStore.getByCnpj` para buscar os dados da empresa correspondente.
   * - Se a empresa for encontrada, retorna apenas a razão social.
   * - Caso o CNPJ não seja informado ou a empresa não seja encontrada, retorna uma string vazia.
   *  
   * @param {string} cnpj CNPJ da empresa a ser buscada.
   * @returns {string} Razão social da empresa, ou string vazia se não encontrada.
  */

  getRazao(cnpj) {

    if (cnpj) {
      let emp = EmpresaStore.getByCnpj(cnpj);
      if (emp) {
        return `${emp.razao_social}`
      }
    }
    return ""

  };

  /**
 * Fecha a exibição de erros e limpa o conteúdo dos erros.
 */
  onCloseErros() {
    this.obs.view_parcelamentos = false
    this.obs.erros = ""
  }

  /**
 * Atualiza a lista de tarefas paginadas com base na empresa selecionada.
 * 
 * @returns {void} Retorna um aviso se nenhuma empresa estiver selecionada. Caso contrário, busca as tarefas.
 */
  handleAtualizaTarefasPaged = async () => {
    this.obs.tarefas_page = 1
    await ParcelamentosStore.handleTasksPaged(this.obs.tarefas_page, this.obs.selectEmpresa.cnpj, this.obs.filter_situacao, this.obs.tipoParcela, this.obs.tipoSubParcela);
  };


  /**
 * Abre a interface para criar uma nova solicitação de crédito.
 * 
 * Este método realiza a consulta de crédito e, em seguida, exibe a janela para solicitar crédito.
 */
  async handleOpenCreate() {

    this.resetSolicitacaoModal();

    ParcelamentosStore.obs.open_solicitar = true

  }

  /**
   * Atualiza o filtro de referência dos parcelamentos e dispara uma nova busca com base nesse filtro.
   *
   * Esta função:
   * - Atualiza o valor observado `filter_referencia` com o filtro informado.
   * - Chama `obs.fetchReferencia(filter)` para obter os dados filtrados conforme a referência escolhida.
   *
   * É utilizada para atualizar a listagem de parcelamentos quando o usuário altera o filtro de referência.
   *
   * @param {string} filter Novo valor de filtro de referência a ser aplicado (ex.: "08/2023", "2023-09", etc.).
   * @returns {void} Não retorna valor; apenas atualiza estado e aciona a busca correspondente.
  */

  handleChangeFilterParcelamentos = (filter) => {
    this.obs.filter_referencia = filter;

    this.obs.fetchReferencia(filter);
  }

  /**
   * Atualiza o filtro de situação dos parcelamentos e recarrega a listagem a partir da primeira página.
   *
   * Esta função:
   * - Atualiza o valor observado `filter_status` com o status selecionado.
   * - Chama `ParcelamentosStore.handleTasksPagedParcelamentos` para buscar os parcelamentos filtrados,
   *   reiniciando a listagem na página 1 e mantendo os demais filtros ativos (task_id e filter_referencia).
   *
   * É utilizada quando o usuário altera o filtro de situação dos parcelamentos (ex.: "pendente", "pago", "atrasado").
   *
   * @param {string} status Novo status a ser aplicado como filtro na listagem.
   * @returns {Promise<void>} Uma promise que se resolve após a atualização do filtro e recarregamento dos dados.
  */

  async handleChangeFilterSituacaoParcelamentos(status) {

    this.obs.filter_status = status

    ParcelamentosStore.handleTasksPagedParcelamentos(1, this.obs.task_id, this.obs.filter_referencia, status);

  }

  /**
 * Atualiza o filtro de status das parcelas e recarrega a listagem a partir da primeira página.
 *
 * Esta função:
 * - Atualiza o valor observado `filter_status_parcelas` com o filtro informado.
 * - Chama `ParcelamentosStore.handleTasksPagedParcelas` para buscar as parcelas filtradas,
 *   reiniciando a listagem na página 1 e mantendo os demais parâmetros já selecionados
 *   (`task_id`, `tributo`, `n_parcelamento` e `periodoEntrada`).
 *
 * É utilizada quando o usuário modifica o filtro de status das parcelas
 * (ex.: "pago", "pendente", "atrasado", "cancelado").
 *
 * @param {string} filter Novo status a ser aplicado como filtro das parcelas.
 * @returns {void} Não retorna valor; apenas atualiza o filtro e dispara a busca correspondente.
 */

  handleChangeFilterStatusParcelas = (filter) => {

    this.obs.filter_status_parcelas = filter;

    ParcelamentosStore.handleTasksPagedParcelas(1, this.obs.task_id, this.obs.tributo, this.obs.n_parcelamento, ParcelamentosStore.obs.periodoEntrada, filter);

  }

  /**
   * Exibe os parcelamentos vinculados a uma tarefa específica selecionada na tabela.
   * 
   * Esta função:
   * - Define o `task_id` e armazena a linha (`row`) selecionada em `edit_row`.
   * - Limpa o filtro de referência (`filter_referencia`), garantindo que a listagem comece sem filtros aplicados.
   * - Define `ParcelamentosStore.obs.open_parcelamentos` como `true`, abrindo o modal ou seção de visualização de parcelamentos.
   * - Chama `ParcelamentosStore.handleTasksPagedParcelamentos` para carregar a primeira página de parcelamentos da tarefa selecionada.
   * - Limpa o filtro de status (`filter_status`), garantindo que a listagem comece sem filtros aplicados.
   * 
   * É acionada quando o usuário clica em uma linha ou botão de “visualizar” na lista de tarefas.
   * 
   * @param {Object} row Objeto da linha selecionada contendo informações da tarefa, incluindo o campo `task_id`.
   * @returns {Promise<void>} Uma promise que resolve após carregar e exibir os parcelamentos da tarefa.
  */

  async handleViewParcelamentos(row) {

    this.obs.task_id = row.task_id

    this.obs.edit_row = row

    this.obs.filter_referencia = ""

    this.obs.filter_status = ""

    this.obs.parcelamentos_page = 1;

    await ParcelamentosStore.handleTasksPagedParcelamentos(1, this.obs.task_id, "", "");

    if (ParcelamentosStore.obs.parcelamentos_length) {

      ParcelamentosStore.obs.open_parcelamentos = true

    }

  }

  /**
   * Exibe as parcelas de um parcelamento específico selecionado na interface.
   * 
   * Esta função:
   * - Define os valores observados `tributo` e `n_parcelamento` com base na linha (`row`) selecionada.
   * - Abre o painel ou modal de visualização de parcelas (`open_parcelas = true`).
   * - Reseta a paginação das parcelas para a primeira página (`parcelas_page = 1`).
   * - Ativa o estado de carregamento (`loading_parcelas = true`) enquanto os dados são buscados.
   * - Chama `ParcelamentosStore.handleTasksPagedParcelas` para carregar a primeira página de parcelas,
   *   com base no `task_id`, `tributo`, `n_parcelamento` e no `periodoEntrada` atual.
   * - Após o carregamento, desativa o estado de carregamento (`loading_parcelas = false`).
   * 
   * É acionada quando o usuário deseja visualizar as parcelas de um parcelamento específico listado.
   * 
   * @param {Object} row Objeto representando a linha da tabela de parcelamentos, contendo `task_id`, `tributo` e `n_parcelamento`.
   * @returns {Promise<void>} Uma promise que resolve após o carregamento das parcelas.
  */

  async handleViewParcelas(row) {

    this.obs.tributo = row.tributo

    this.obs.n_parcelamento = row.n_parcelamento

    this.obs.parcelas_page = 1;

    ParcelamentosStore.obs.loading_parcelas = true

    this.obs.filter_status_parcelas = "";

    await ParcelamentosStore.handleTasksPagedParcelas(1, row.task_id, row.tributo, row.n_parcelamento, ParcelamentosStore.obs.periodoEntrada, this.obs.filter_status_parcelas);

    ParcelamentosStore.obs.loading_parcelas = false

    if (ParcelamentosStore.obs.parcelas_length) {

      ParcelamentosStore.obs.open_parcelas = true

    }

  }

  /**
   * Prepara e abre a interface de edição para uma tarefa de parcelamento selecionada.
   * 
   * Esta função:
   * - Define o tributo da tarefa selecionada no estado observado (`obs.tributo`).
   * - Armazena os dados completos da linha selecionada em `edit_row`, para uso durante a edição.
   * - Ativa o modal ou seção de edição de tarefa (`open_edit_task_parcelamento = true`).
   * 
   * É utilizada quando o usuário clica em "editar" uma tarefa listada na interface.
   * 
   * @param {Object} row Objeto representando a linha da tarefa a ser editada, contendo ao menos o campo `tributo`.
   * @returns {Promise<void>} Uma promise que resolve imediatamente após atualizar os estados e abrir o editor.
  */

  async handleEditTasks(row) {

    this.obs.tributo = row.tributo

    this.obs.edit_row = row

    this.obs.open_edit_task_parcelamento = true;

  }

  /**
   * Atualiza os dados de uma tarefa de parcelamento em edição e recarrega a lista de tarefas.
   * 
   * Esta função:
   * - Fecha o modal ou painel de edição de tarefa (`open_edit_task_parcelamento = false`).
   * - Chama `ParcelamentosStore.handleTasksEditTasks` passando os dados editados:
   *   - `_id`: Identificador da tarefa.
   *   - `n_parcelamentos`: Número de parcelamentos atualizado.
   *   - `ativo`: Status de ativação da tarefa.
   *   - `dia_agendamento`: Dia agendado para execução da tarefa.
   * - Após a atualização, recarrega a listagem de tarefas na primeira página através de `handleBuscaTarefasPaged(1)`.
   * 
   * É chamada após o usuário confirmar a edição de uma tarefa de parcelamento.
   * 
   * @returns {Promise<void>} Uma promise que resolve após a atualização da tarefa e recarregamento da lista.
  */

  async handleUpdateTask() {

    this.obs.open_edit_task_parcelamento = false;

    await ParcelamentosStore.handleTasksEditTasks(this.obs.edit_row._id, this.obs.edit_row.n_parcelamentos, this.obs.edit_row.ativo, this.obs.edit_row.dia_agendamento);

    this.handleBuscaTarefasPaged(1);

  }

  /**
   * Define o período de entrada com base em uma data selecionada pelo usuário e atualiza os dados relacionados.
   * 
   * Esta função:
   * - Extrai a data do objeto `value`, tratando cenários onde a data pode estar ausente ou inválida.
   * - Caso a data seja válida:
   *   - Define `ParcelamentosStore.obs.periodoEntrada` como um array contendo:
   *     - O primeiro dia do mês da data selecionada (formato: "YYYY-MM-DD").
   *     - O último dia do mesmo mês (formato: "YYYY-MM-DD").
   * - Caso a data seja inválida ou não informada:
   *   - Define `ParcelamentosStore.obs.periodoEntrada` como `null`.
   * - Também define `ParcelamentosStore.obs.dataEntrada` com o valor original recebido.
   * - Após a atualização, chama `fetchOptions(1)` para atualizar os dados com base no novo período.
   * 
   * Utilizada para controlar filtros por período de vencimento de parcelas ou apurações.
   * 
   * @param {any} value Objeto representando a data selecionada. Espera-se que contenha a propriedade `$d` (ex: do Day.js).
   * @returns {Promise<void>} Uma promise que resolve após a atualização do período e recarregamento dos dados.
  */

  async handlePeriodo(value) {

    const data = value && value.$d ? value.$d : "";

    if (!data || data == "Invalid Date") {

      ParcelamentosStore.obs.periodoEntrada = null

    } else {

      ParcelamentosStore.obs.periodoEntrada = [moment(data).startOf("month").format("YYYY-MM-DD"), moment(data).endOf("month").format("YYYY-MM-DD")];

    }

    ParcelamentosStore.obs.dataEntrada = value;


    await this.obs.fetchOptions(1);

  }

  /**
   * Realiza a busca de parcelas com base nos filtros atualmente selecionados.
   * 
   * Esta função:
   * - Reinicia a paginação das parcelas para a primeira página, garantindo que a busca comece do início.
   * - Chama a função `handleTasksPagedParcelas` da store `ParcelamentosStore`, responsável por realizar a requisição e atualização das parcelas com base nos filtros aplicados.
   * 
   * Os filtros considerados na chamada são:
   * - `this.obs.task_id`: identificador da tarefa selecionada.
   * - `this.obs.tributo`: tipo de tributo associado à tarefa.
   * - `this.obs.n_parcelamento`: número ou identificador do parcelamento.
   * - `this.obs.filter_status_parcelas`: status que se encontra atualmente na parcela.
   * - `ParcelamentosStore.obs.periodoEntrada`: intervalo de datas definido para filtrar as parcelas (geralmente início e fim do mês).
   * 
   * Utilizada no contexto de filtros aplicados em listagens de parcelamentos vinculados a tarefas.
   * Esta função é acionada após o usuário selecionar ou alterar filtros relacionados a tarefas do parcelamento.
   * 
   * @returns {Promise<void>} Uma promise que resolve após a execução da busca e atualização das parcelas na store.
  */

  handleBuscaTarefasFilter = async () => {

    this.obs.parcelas_page = 1

    await ParcelamentosStore.handleTasksPagedParcelas(1, this.obs.task_id, this.obs.tributo, this.obs.n_parcelamento, ParcelamentosStore.obs.periodoEntrada, this.obs.filter_status_parcelas);
  };

  /**
   * Encerra a visualização do modal de parcelas e reseta os filtros relacionados ao período de entrada.
   * 
   * Esta função:
   * - Define `ParcelamentosStore.obs.open_parcelas` como `false`, fechando o modal de exibição de parcelas.
   * - Limpa os dados de filtro de período:
   *   - Define `ParcelamentosStore.obs.periodoEntrada` como `null`, removendo o intervalo de datas previamente selecionado.
   *   - Define `ParcelamentosStore.obs.dataEntrada` como `null`, limpando a data original usada como base para o filtro.
   * 
   * Utilizada para restaurar o estado inicial da interface após o usuário fechar o modal de visualização de parcelas, garantindo que nenhum filtro anterior interfira em futuras interações.
   * 
   * @returns {void} Não retorna valor. Apenas atualiza o estado da store relacionada.
  */

  handleCloseParcelasModal = () => {

    ParcelamentosStore.obs.open_parcelas = false;

    ParcelamentosStore.obs.periodoEntrada = null;

    ParcelamentosStore.obs.dataEntrada = null;

  };

  /**
 * Renderiza o status da certidão como uma tag estilizada.
 * 
 * @param {any} cell - Célula da tabela (não utilizado).
 * @param {object} row - Objeto representando a linha.
 * @returns {JSX.Element} - Tag estilizada com o status da certidão.
 */
  statusFormatter(cell, row) {
    return getTag(row.status);
  }

  /**
   * Renderiza um componente visual (`Tag`) representando a situação da parcela em uma tabela.
   * 
   * Esta função:
   * - Recebe como parâmetros:
   *   - `cell`: valor bruto da célula (não utilizado diretamente nesta função).
   *   - `row`: objeto que representa a linha da tabela, contendo os dados da parcela, especialmente a propriedade `situacao`.
   * - Com base no valor de `row.situacao`, retorna um componente `<Tag>` com:
   *   - Um texto correspondente ao status: "Pago", "Vencida", "Pendente" ou qualquer outro valor padrão.
   *   - Classes específicas aplicadas para controle visual de cor/estilo, baseadas no status da parcela.
   *   - Estilização inline padronizada com largura de 70% e alinhamento central.
   * 
   * Situações tratadas:
   * - `"Pago"`: aplica estilo padrão.
   * - `"Vencida"`: aplica a classe `tagNao` para indicar inadimplência.
   * - `"Pendente"`: aplica a classe `tagEfeitoNegativa` para indicar pendência.
   * - Qualquer outro valor: aplica a classe `tagNovo` como estilo genérico para estados não mapeados.
   * 
   * Utilizada na renderização de tabelas de parcelas para indicar de forma visual e destacada a situação atual de cada item.
   * 
   * @param {any} cell Valor da célula (não utilizado diretamente).
   * @param {Object} row Objeto representando os dados da linha da tabela, contendo a propriedade `situacao`.
   * @returns {JSX.Element} Um elemento React `<Tag>` estilizado conforme a situação da parcela.
  */

  situacaoParcela(cell, row) {
    switch (row.situacao) {
      case "Pago": return <Tag className="tagConfirmacao tagDownload " style={{ width: "70%", textAlign: "center" }}>Pago</Tag>
      case "Vencida": return <Tag className="tagConfirmacao tagDownload tagNao" style={{ width: "70%", textAlign: "center" }}>Vencida</Tag>
      case "Pendente": return <Tag className="tagConfirmacao tagDownload tagEfeitoNegativa" style={{ width: "70%", textAlign: "center" }}>Pendente</Tag>
      case "Cancelada": return <Tag className="tagConfirmacao tagDownload tagSemArquivos" style={{ width: "70%", textAlign: "center" }}>Cancelada</Tag>
      default: return <Tag className="tagConfirmacao tagDownload tagNovo" style={{ width: "70%", textAlign: "center" }}>{row.situacao}</Tag>
    }
  }

  /**
   * Renderiza um componente visual (`Tag`) representando a situação de uma tarefa em uma tabela.
   * 
   * Esta função:
   * - Recebe como parâmetros:
   *   - `cell`: valor bruto da célula (não utilizado diretamente nesta função).
   *   - `row`: objeto que representa a linha da tabela, contendo os dados da tarefa, especialmente a propriedade `situacao`.
   * - Avalia o valor de `row.situacao` e retorna um componente `<Tag>` estilizado com base nesse valor.
   * 
   * Situações tratadas:
   * - `"Em Dia"`: indica que a tarefa está regular, aplicando o estilo padrão.
   * - `"Pendente"`: indica que há pendências associadas à tarefa, aplicando a classe `tagProcessando`.
   * - `"Atrasado"`: indica atraso ou inadimplência, aplicando a classe `tagNao`.
   * - Qualquer outro valor: retorna o texto `"Não Encontrado"` com estilo genérico `tagNovo`.
   * 
   * Todas as tags retornadas:
   * - Utilizam a classe base `tagConfirmacao tagDownload`.
   * - Aplicam estilos inline com largura de 70% e alinhamento centralizado, garantindo consistência visual na tabela.
   * 
   * Utilizada para exibir o status atual de tarefas dentro de listagens ou grids de controle, proporcionando uma leitura rápida e visual do estado de cada item.
   * 
   * @param {any} cell Valor da célula (não utilizado diretamente).
   * @param {Object} row Objeto representando os dados da linha da tabela, contendo a propriedade `situacao`.
   * @returns {JSX.Element} Um elemento React `<Tag>` estilizado com base na situação da tarefa.
  */

  situacaoTarefa(cell, row) {
    switch (row.situacao) {
      case "Em Dia": return <Tag className="tagConfirmacao tagDownload" style={{ width: "70%", textAlign: "center" }}>Em Dia</Tag>
      case "Pendente": return <Tag className="tagConfirmacao tagDownload tagProcessando" style={{ width: "70%", textAlign: "center" }}>Pendências</Tag>
      case "Atrasado": return <Tag className="tagConfirmacao tagDownload tagNao" style={{ width: "70%", textAlign: "center" }}>Atrasado</Tag>
      case "Não Encontrado": return <Tag className="tagConfirmacao tagAguardandoDownload " style={{ width: "70%", textAlign: "center" }}>Não Encontrado</Tag>
      default: return <Tag className="tagConfirmacao tagDownload tagNovo" style={{ width: "70%", textAlign: "center" }}>Indisponível</Tag>
    }
  }

  /**
   * Renderiza um componente visual (`Tag`) representando a situação de um parcelamento em uma tabela.
   * 
   * Esta função:
   * - Recebe como parâmetros:
   *   - `cell`: valor bruto da célula (não utilizado diretamente nesta função).
   *   - `row`: objeto que representa a linha da tabela, contendo os dados do parcelamento, especialmente a propriedade `situacao`.
   * - Avalia o valor de `row.situacao` e retorna um componente `<Tag>` com texto e estilo correspondentes ao estado do parcelamento.
   * 
   * Situações tratadas:
   * 
   * **Encerrado:**  
   * Retorna a tag com o texto `"ENCERRADO"` e estilo padrão (`tagConfirmacao tagDownload`).  
   * 
   * **Pendente:**  
   * Retorna a tag com o texto `"PENDENTE"` e aplica a classe `tagProcessando`, indicando que o parcelamento está ativo, em andamento ou aguardando alguma ação.  
   * 
   * **Atrasado:**  
   * Retorna a tag com o texto `"ATRASADO"` e aplica a classe `tagNao`, destacando inadimplência ou atraso.  
   * 
   * **Padrão:**  
   * Para qualquer outro valor de `row.situacao` não listado acima, retorna o próprio texto do status dentro da tag, utilizando a classe `tagNovo`.
   * 
   * Todas as tags:
   * - Utilizam o conjunto base de classes `tagConfirmacao tagDownload`.
   * - Possuem estilo inline padronizado com largura de 70% e texto centralizado (`textAlign: "center"`).
   * 
   * Utilizada para exibir visualmente o status de parcelamentos em listagens, permitindo identificar rapidamente se um parcelamento está encerrado, pendente ou Atrasado.
   * 
   * @param {any} cell Valor da célula (não utilizado diretamente).
   * @param {Object} row Objeto representando os dados da linha da tabela, contendo a propriedade `situacao`.
   * @returns {JSX.Element} Um elemento React `<Tag>` estilizado conforme a situação do parcelamento.
  */

  situacaoParcelamento(cell, row) {
    switch (row.status) {
      case "Encerrado":
        return <Tag className="tagConfirmacao tagDownload" style={{ width: "70%", textAlign: "center" }}>ENCERRADO</Tag>
      case "Pendente":
        return <Tag className="tagConfirmacao tagDownload tagProcessando" style={{ width: "70%", textAlign: "center" }}>PENDENTE</Tag>
      case "Atrasado":
        return <Tag className="tagConfirmacao tagDownload tagNao" style={{ width: "70%", textAlign: "center" }}>ATRASADO</Tag>
      default:
        return <Tag className="tagConfirmacao tagDownload tagNovo" style={{ width: "70%", textAlign: "center" }}>{row.status || "Não Encontrado"}</Tag>
    }
  }

  /**
 * Formata uma data adicionando 3 horas e exibe a data e hora formatadas.
 * 
 * @param {string} cell - Data a ser formatada.
 * @param {object} row - Objeto representando a linha.
 * @returns {string} - Data e hora formatadas.
 */
  dateFormatter(cell, row) {

    if (cell) {

      return moment(cell).add(3, "hour").format("DD/MM/YYYY");

    }

    return "Sem atualização";

  };

  /**
 * Renderiza um botão para visualizar os detalhes de uma linha.
 * 
 * @param {any} cell - Célula da tabela (não utilizado).
 * @param {object} row - Objeto representando a linha.
 * @returns {JSX.Element} - Botão para visualizar detalhes.
 */
  viewErros = (cell, row) => {
    return (
      <MDBBtn
        disabled={!row._id}
        color="default"
        rounded
        size="sm"
        onClick={(e) => this.handleViewErros(row)}
      >
        <img src="/images/view.png" width="18px" />
      </MDBBtn>
    );
  }

  /**
   * Renderiza um botão de ação para visualização dos parcelamentos vinculados à linha atual da tabela.
   * 
   * Esta função:
   * - Recebe como parâmetros:
   *   - `cell`: valor da célula (não utilizado diretamente nesta função).
   *   - `row`: objeto que representa os dados da linha da tabela, incluindo informações como `_id` e `status`.
   * - Retorna um botão (`<MDBBtn>`) com ícone (`<AppIcon>`) que, ao ser clicado, chama a função `handleViewParcelamentos(row)`.
   * 
   * Regras de exibição:
   * - O botão é **desabilitado** (`disabled`) quando:
   *   - A linha não possui um `_id` válido.
   *   - O `status` da linha é igual a `0`, indicando que a ação não deve estar disponível.
   * 
   * Características do botão:
   * - Cor: `default`
   * - Estilo: `rounded`
   * - Tamanho: `sm` (pequeno)
   * - Classe CSS: `botaoDownload` (possivelmente usada para estilização geral dos botões da tabela)
   * - Ícone: utiliza o componente `<AppIcon>` com o ícone `"quick_reference_all"`, tamanho 24 e cor `#2b82bc`
   * 
   * Utilizada para permitir que o usuário visualize os parcelamentos relacionados a um item específico diretamente a partir da tabela, desde que a linha esteja apta para essa ação.
   * 
   * @param {any} cell Valor da célula (não utilizado diretamente).
   * @param {Object} row Objeto representando os dados da linha da tabela, contendo `_id` e `status` para controle de disponibilidade.
   * @returns {JSX.Element} Um botão React (`<MDBBtn>`) com ícone, que dispara a visualização dos parcelamentos ao ser clicado.
  */

  viewParcelamentos = (cell, row) => {
    return (
      <MDBBtn
        disabled={!row._id || row.status == 0}
        color="default"
        rounded
        className="botaoDownload"
        size="sm"
        onClick={(e) => this.handleViewParcelamentos(row)}
      >
        <AppIcon name={"quick_reference_all"} size={24} color="#2b82bc" />
      </MDBBtn>
    );
  }

  /**
   * Renderiza um botão de ação para visualização das parcelas associadas à linha atual da tabela.
   * 
   * Esta função:
   * - Recebe como parâmetros:
   *   - `cell`: valor da célula (não utilizado diretamente nesta função).
   *   - `row`: objeto representando os dados da linha da tabela, contendo as informações da entidade (como `_id`).
   * - Retorna um botão (`<MDBBtn>`) com ícone (`<AppIcon>`) que, ao ser clicado, executa a função `handleViewParcelas(row)`.
   * 
   * Regras de disponibilidade:
   * - O botão será **desabilitado** (`disabled`) caso o campo `row._id` não esteja presente ou seja inválido.
   *   - Essa verificação evita que a função seja executada para itens que não possuem identificação válida.
   * 
   * @param {any} cell Valor da célula (não utilizado diretamente).
   * @param {Object} row Objeto representando os dados da linha da tabela, contendo `_id` como identificador principal.
   * @returns {JSX.Element} Um botão React (`<MDBBtn>`) com ícone, que aciona a função de visualização de parcelas ao ser clicado.
  */

  viewParcelas = (cell, row) => {
    return (
      <MDBBtn
        disabled={!row._id}
        color="default"
        rounded
        size="sm"
        onClick={(e) => this.handleViewParcelas(row)}
      >
        <AppIcon name={"quick_reference_all"} size={24} color="#2b82bc" />
      </MDBBtn>
    );
  }

  /**
   * Renderiza um botão de ação para edição de um parcelamento associado à linha atual da tabela.
   * 
   * Esta função:
   * - Recebe como parâmetros:
   *   - `cell`: valor da célula (não utilizado diretamente nesta função).
   *   - `row`: objeto representando os dados da linha da tabela, contendo o identificador do parcelamento (`_id`).
   * - Retorna um botão (`<MDBBtn>`) com ícone (`<AppIcon>`) que, ao ser clicado, executa a função `handleEditTasks(row)`.
   * 
   * Regras de disponibilidade:
   * - O botão será **desabilitado** (`disabled`) quando o campo `row._id` estiver ausente ou for inválido.
   *   - Essa verificação garante que a ação de edição só esteja disponível para itens válidos com identificação definida.
   * 
   * @param {any} cell Valor da célula (não utilizado diretamente).
   * @param {Object} row Objeto representando os dados da linha da tabela, contendo o campo `_id`.
   * @returns {JSX.Element} Um botão React (`<MDBBtn>`) com ícone de edição, que chama `handleEditTasks(row)` ao ser clicado.
  */

  editParcelamento = (cell, row) => {
    return (
      <MDBBtn
        disabled={!row._id}
        color="default"
        rounded
        size="sm"
        onClick={(e) => this.handleEditTasks(row)}
      >
        <AppIcon name={"edit"} size={24} color="#2b82bc" />
      </MDBBtn>
    );
  }

  /**
   * Renderiza um botão de ação para download da guia associada à parcela exibida na linha da tabela.
   * 
   * Esta função:
   * - Recebe como parâmetros:
   *   - `cell`: valor da célula (não utilizado nesta função).
   *   - `row`: objeto representando os dados da linha da tabela, incluindo os campos `_id` e `arquivo`.
   * - Retorna um botão (`<MDBBtn>`) com ícone (`<AppIcon>`) que, ao ser clicado, executa a função `handleDownloadGuia(row)`, responsável por realizar o download da guia da parcela.
   * 
   * Regras de disponibilidade:
   * - O botão será **desabilitado** (`disabled`) quando:
   *   - A parcela (`row`) não possuir um `_id` válido.
   *   - O campo `row.arquivo` for diferente de `true`, indicando que não há arquivo disponível para download.
   *   - Isso evita a tentativa de download em registros inválidos ou incompletos.
   * 
   * Características do botão:
   * - Cor: `default`
   * - Estilo: `rounded`
   * - Tamanho: `sm` (pequeno)
   * - Classe CSS: `botaoDownload` (provavelmente usada para padronizar o estilo de botões de download no sistema)
   * - Ícone: usa o componente `<AppIcon>` com o ícone `"download"`, tamanho `24` e cor `#2b82bc`, simbolizando a ação de baixar o arquivo.
   * 
   * @param {any} cell Valor da célula (não utilizado diretamente).
   * @param {Object} row Objeto representando os dados da linha da tabela, contendo `_id` e `arquivo`.
   * @returns {JSX.Element} Um botão React (`<MDBBtn>`) com ícone de download, que executa `handleDownloadGuia(row)` ao ser clicado.
  */

  downloadParcela = (cell, row) => {
    return (
      <MDBBtn
        disabled={!row._id || row.arquivo !== true}
        color="default"
        rounded
        className="botaoDownload"
        size="sm"
        onClick={(e) => this.handleDownloadGuia(row)}
      >
        <AppIcon name={"download"} size={24} color="#2b82bc" />
      </MDBBtn>
    );
  }

  /**
   * Realiza o download da guia de pagamento referente a uma parcela específica.
   * 
   * Esta função:
   * - Recebe como parâmetro um objeto `row`, que representa os dados da linha da tabela contendo informações da parcela.
   * - Utiliza esses dados para chamar o método `downloadArquivos` da store `ParcelamentosStore`, responsável por buscar e iniciar o download do arquivo correspondente.
   * 
   * Parâmetros utilizados na chamada:
   * - `row.task_id`: identificador da tarefa relacionada à parcela.
   * - `row.n_parcelamento`: número do parcelamento (ou string vazia, caso não informado).
   * - `row.n_parcela`: número da parcela.
   * - `row.tributo`: tipo de tributo relacionado (ou string vazia, caso não informado).
   * 
   * Requisitos para execução:
   * - Os dados mínimos necessários (`task_id`, `n_parcela`) devem estar presentes no objeto `row`.
   * - É recomendável validar a existência do arquivo disponível antes de chamar essa função (o que normalmente é feito na função `downloadParcela` que chama esta).
   * 
   * @param {Object} row Objeto contendo os dados da parcela, incluindo `task_id`, `n_parcelamento`, `n_parcela` e `tributo`.
   * @returns {Promise<void>} Uma promise que se resolve após a solicitação de download ser processada.
  */

  handleDownloadGuia = async (row: any) => {

    await ParcelamentosStore.downloadArquivos(row.task_id, row.n_parcelamento || "", row.n_parcela, row.tributo || "");

  };

  /**
   * Gera uma lista de opções numéricas de dias para preenchimento de um `<select>`.
   * 
   * Esta função:
   * - Retorna uma sequência de elementos `<option>`.
   * - Cada `<option>` representa um número de 1 a 20, usado geralmente em campos de quantidades de dias.
   * - O `value` de cada opção é igual ao número exibido no texto da opção.
   * 
   * Finalidade:
   * - Utilizada para popular campos `<select>` com dias numéricos de forma direta no JSX.
   * - Evita a escrita manual de múltiplos `<option>` em HTML, centralizando a lógica em uma única função.
   * - Pode ser facilmente adaptada ou estendida para gerar faixas diferentes de números, se necessário.
   * 
   * @returns {JSX.Element} Um fragmento JSX contendo opções de 1 a 20 como elementos `<option>`.
  */

  handleDays() {
    return (<>
      <option value={10}>10</option>
      <option value={11}>11</option>
      <option value={12}>12</option>
      <option value={13}>13</option>
      <option value={14}>14</option>
      <option value={15}>15</option>
      <option value={16}>16</option>
      <option value={17}>17</option>
      <option value={18}>18</option>
      <option value={19}>19</option>
      <option value={20}>20</option>
      <option value={21}>21</option>
      <option value={22}>22</option>
      <option value={23}>23</option>
      <option value={24}>24</option>
      <option value={25}>25</option>
    </>);
  }

  /**
 * Formata um valor de texto para exibição em letras maiúsculas.
 * 
 * @param {string} cell - Valor de texto a ser formatado.
 * @param {object} row - Objeto representando a linha.
 * @returns {string} - Texto em letras maiúsculas.
 */
  tipoFormat = (cell) => {
    const tipos = {
      "2.1": "Simplificado Previdenciário",
      "2.2": "Não Previdenciário",
      "3.1": "Parcelamento Lei 12.996/2014",
      "3.2": "Parcelamento Lei 11.941/2009",
      "3.3": "Previdenciário INSS",
      "3.4": "Previdenciário PERT",
      "3.5": "Especiais (Solicitar e Acompanhar)",
      "4.1": "Parcelamento do Simples Nacional - Ordinário",
      "4.2": "Parcelamento do Simples Nacional - Especial",
      "4.3": "Programa Especial de Regularização Tributária do Simples Nacional",
      "4.4": "Programa de Reescalonamento do Pagamento de Débitos no Âmbito do Simples Nacional",
      "4.5": "Parcelamento do Microempreendedor Individual - Ordinário",
      "4.6": "Parcelamento do Microempreendedor Individual - Especial",
      "4.7": "Programa Especial de Regularização Tributária do Microempreendedor Individual",
      "4.8": "Programa de Reescalonamento do Pagamento de Débitos no Âmbito do Microempreendedor Individual",
      "5.1": "Prorefis (SEFA)",
      "5.2": "Acompanhar Parcelamento (SEFA)",
    };

    return tipos[cell] || "PGFN";
  };

  /**
 * Exibe os detalhes de erros associados a uma linha.
 * 
 * @param {object} row - Objeto representando a linha.
 */
  handleViewErros = async (row: any) => {
    this.obs.erros = row.error

    if (this.obs.erros != "" && this.obs.erros != null) {
      this.obs.view_parcelamentos = true
    } else {
      toast.warn("Nenhum erro encontrado!", {});
      return
    }
  };

  /**
   * Formata o valor do campo `tributo`, convertendo-o para letras maiúsculas.
   * 
   * Esta função:
   * - Recebe como parâmetros:
   *   - `cell`: valor da célula da tabela, correspondente ao nome do tributo.
   *   - `row`: objeto com os dados da linha da tabela (não utilizado diretamente nesta função).
   * - Verifica se o valor de `cell` existe:
   *   - Caso exista, retorna a string em letras maiúsculas utilizando `toUpperCase()`.
   *   - Caso contrário, retorna uma string vazia (`""`), evitando que valores `undefined` ou `null` sejam exibidos na tabela.
   * 
   * @param {any} cell Valor da célula, correspondente ao nome do tributo.
   * @param {Object} row Objeto da linha da tabela (não utilizado diretamente).
   * @returns {string} O nome do tributo formatado em letras maiúsculas, ou string vazia se não definido.
  */

  tributoFormatter = (cell, row) => {

    if (cell) {

      return cell.toUpperCase();

    }

    return "";
  }

  /**
   * Formata valores numéricos em formato monetário para exibição em tabelas.
   * 
   * Esta função:
   * - Recebe como parâmetros:
   *   - `cell`: valor da célula da tabela, que representa um valor monetário (ex: valor de uma parcela ou total).
   *   - `row`: objeto representando os dados da linha da tabela (não utilizado diretamente nesta função).
   * - Utiliza a biblioteca `numeral` para aplicar a formatação monetária padrão.
   * 
   * Formatação aplicada:
   * - Formato: `"$ 0,0.00"`
   *   - Insere o símbolo de moeda (`$`), separadores de milhar (`,`) e duas casas decimais (`.00`).
   *   - Exemplo:
   *     - Entrada: `1234.5` → Saída: `$ 1,234.50`
   *     - Entrada: `0` → Saída: `$ 0.00`
   * 
   * @param {number|string} cell Valor numérico da célula a ser formatado.
   * @param {Object} row Objeto da linha da tabela (não utilizado diretamente).
   * @returns {string} O valor formatado como moeda, usando a biblioteca `numeral`.
  */

  valorFormatter = (cell, row) => {

    return numeral(cell).format("$ 0,0.00");

  }

  /**
   * Restaura o estado inicial do modal de solicitação, limpando dados e redefinindo campos observáveis.
   * 
   * Esta função:
   * - É responsável por limpar todos os dados temporários utilizados no processo de solicitação, garantindo que o modal esteja em seu estado padrão ao ser reaberto.
   * - Redefine os observáveis da propriedade `obs` relacionados à solicitação, empresa, listas de itens e configurações visuais.
   * 
   * Ações executadas:
   * 
   * - **Empresa selecionada:**
   *    - `this.obs.selectEmpresaSolicitacao` é redefinido chamando `newEmpresa()`, retornando uma nova instância padrão do objeto de empresa.
   * 
   * - **Exibição de seções do modal:**
   *    - `this.obs.showPGFN`, `this.obs.showReceita`, `this.obs.showSimples` e `this.obs.showEspeciais` são definidos como `false`, ocultando as seções correspondentes no modal.
   * 
   * - **Configuração de envio:**
   *    - `this.obs.sendEmail` é definido como `false`, desmarcando a opção de envio automático por e-mail.
   * 
   * - **Limpeza de listas:**
   *    - `this.obs.list` é resetado para uma lista vazia.
   *    - Listas específicas por tipo de dívida ou lei também são limpas:
   *      - `pgfn`, `itens_simplificado`, `itens_nao_previdenciario`, `lei_12996`, `lei_11941`,
   *        `previdenciario_inss`, `previdenciario_pert`, `especiais`.
   * 
   * - **Campos adicionais:**
   *    - `this.obs.email` é redefinido como uma string vazia.
   *    - `this.obs.dia_agendamento` é definido como `10`, representando o valor padrão para o campo de agendamento.
   * 
   * @returns {void} A função não retorna valor. Apenas redefine estados observáveis relacionados ao modal de solicitação.
  */

  resetSolicitacaoModal = () => {
    this.obs.selectEmpresaSolicitacao = newEmpresa();

    this.obs.showPGFN = false;
    this.obs.showReceita = false;
    this.obs.showSimples = false;
    this.obs.showEspeciais = false;
    this.obs.showSefa = false;

    this.obs.list = [];

    this.obs.pgfn = [];
    this.obs.itens_simplificado = [];
    this.obs.itens_nao_previdenciario = [];
    this.obs.lei_12996 = [];
    this.obs.lei_11941 = [];
    this.obs.previdenciario_inss = [];
    this.obs.previdenciario_pert = [];
    this.obs.especiais = [];
    this.obs.sefa_prorefis = [];
    this.obs.sefa_acompanhar = [];

    this.obs.dia_agendamento = 10;
  };

  /**
   * Manipula a seleção de uma empresa no processo de solicitação, buscando suas tarefas ativas e atualizando o estado do modal com base nas configurações associadas.
   * 
   * Esta função:
   * - É chamada quando o usuário seleciona uma empresa no modal de solicitação de parcelamentos.
   * - Inicializa o modal com os dados corretos, com base nas tarefas ativas associadas ao CNPJ da empresa.
   * 
   * Etapas da função:
   * 
   * - **Validação da empresa:**
   *    - Se o parâmetro `empresa` estiver ausente ou não contiver um CNPJ válido:
   *      - Executa `resetSolicitacaoModal()` para limpar o estado atual.
   *      - Interrompe a execução (`return`).
   * 
   * - **Reset inicial:**
   *    - Mesmo com CNPJ válido, o estado do modal é limpo inicialmente para evitar conflitos ou dados residuais.
   * 
   * - **Atualiza a empresa selecionada:**
   *    - Atribui `empresa` ao estado observável `this.obs.selectEmpresaSolicitacao`.
   * 
   * - **Busca tarefas ativas:**
   *    - Chama `ParcelamentosStore.getTarefasAtivasPorEmpresa(empresa.cnpj)` para obter tarefas associadas.
   *    - Se nenhuma tarefa for retornada, a função é encerrada.
   * 
   * - **Processamento das tarefas retornadas:**
   *    Para cada tarefa, são extraídas as seguintes propriedades:
   *    - `tipo_p`: tipo primário da tarefa (1: PGFN, 2: Receita, 3: Especiais).
   *    - `tipo_s`: tipo secundário da tarefa (ex: "2.1", "3.4", etc.).
   *    - `n_parcelamentos`: lista de números de parcelamentos associados.
   *    - `dia_agendamento`: valor opcional usado para preencher o campo de agendamento.
   *    - `send_email`: flag que indica se o envio por e-mail está habilitado.
   *    - `email`: endereço de e-mail configurado para a tarefa.
   *    - `certificado_empresa`: certificado escolhido para autenticação no E-cac.
   * 
   *    - **Tipo PGFN (`tipo_p === 1`):**
   *      - Ativa a seção PGFN no modal (`showPGFN = true`).
   *      - Adiciona os `n_parcelamentos` à lista `pgfn`, sem duplicações (`Set`).
   * 
   *    - **Tipo Receita (`tipo_p === 2`):**
   *      - Ativa a seção Receita (`showReceita = true`).
   *      - Adiciona `tipo_s` à lista de tipos (`list`), se ainda não estiver presente.
   *      - Dependendo do valor de `tipo_s`, adiciona os `n_parcelamentos` às listas específicas:
   *        - `"2.1"` → `itens_simplificado`
   *        - `"2.2"` → `itens_nao_previdenciario`
   * 
   *    - **Tipo Especiais (`tipo_p === 3`):**
   *      - Ativa a seção Especiais (`showEspeciais = true`).
   *      - Adiciona `tipo_s` à lista `list`.
   *      - Dependendo de `tipo_s`, os parcelamentos são adicionados às listas específicas:
   *        - `"3.1"` → `lei_12996`
   *        - `"3.2"` → `lei_11941`
   *        - `"3.3"` → `previdenciario_inss`
   *        - `"3.4"` → `previdenciario_pert`
   *        - `"3.5"` → `especiais`
   * 
   *    - **Outras configurações opcionais:**
   *      - Se houver `dia_agendamento`, ele é atribuído a `obs.dia_agendamento`.
   *      - Se houver `send_email`, o valor é aplicado a `obs.sendEmail`.
   *      - Se houver `email`, é atribuído a `obs.email`.
   * 
   * 
   * @param {IEmpresa} empresa Objeto da empresa selecionada, contendo ao menos o campo `cnpj`.
   * @returns {Promise<void>} Uma promise que se resolve após o carregamento e processamento das tarefas da empresa.
  */

  handleSelecionaEmpresaSolicitacao = async (empresa: IEmpresa) => {
    if (!empresa?.cnpj) {
      this.resetSolicitacaoModal();
      return;
    }

    this.resetSolicitacaoModal();

    this.obs.selectEmpresaSolicitacao = empresa;

    const tarefas = await ParcelamentosStore.getTarefasAtivasPorEmpresa(empresa.cnpj);

    if (tarefas.length === 0) {
      return;
    }

    for (const tarefa of tarefas) {
      const { tipo_p, tipo_s, n_parcelamentos, dia_agendamento, send_email, email } = tarefa;

      if (tipo_p === 1) {
        this.obs.showPGFN = true;
        this.obs.pgfn = [...new Set([...this.obs.pgfn, ...(n_parcelamentos || [])])];
      }

      if (tipo_p === 2) {
        this.obs.showReceita = true;
        if (!this.obs.list.includes(tipo_s)) this.obs.list.push(tipo_s);

        if (tipo_s === "2.1") {
          this.obs.itens_simplificado = [...new Set([...this.obs.itens_simplificado, ...(n_parcelamentos || [])])];
        }

        if (tipo_s === "2.2") {
          this.obs.itens_nao_previdenciario = [...new Set([...this.obs.itens_nao_previdenciario, ...(n_parcelamentos || [])])];
        }
      }

      if (tipo_p === 3) {
        this.obs.showEspeciais = true;
        if (!this.obs.list.includes(tipo_s)) this.obs.list.push(tipo_s);

        if (tipo_s === "3.1") {
          this.obs.lei_12996 = [...new Set([...this.obs.lei_12996, ...(n_parcelamentos || [])])];
        }

        if (tipo_s === "3.2") {
          this.obs.lei_11941 = [...new Set([...this.obs.lei_11941, ...(n_parcelamentos || [])])];
        }

        if (tipo_s === "3.3") {
          this.obs.previdenciario_inss = [...new Set([...this.obs.previdenciario_inss, ...(n_parcelamentos || [])])];
        }

        if (tipo_s === "3.4") {
          this.obs.previdenciario_pert = [...new Set([...this.obs.previdenciario_pert, ...(n_parcelamentos || [])])];
        }

        if (tipo_s === "3.5") {
          this.obs.especiais = [...new Set([...this.obs.especiais, ...(n_parcelamentos || [])])];
        }
      }

      if (tipo_p === 4) {
        this.obs.showSimples = true;
        if (!this.obs.list.includes(tipo_s)) this.obs.list.push(tipo_s);

        if (tipo_s === "4.1") {
          this.obs.parcsn = [...new Set([...this.obs.parcsn, ...(n_parcelamentos || [])])];
        }

        if (tipo_s === "4.2") {
          this.obs.parcsn_esp = [...new Set([...this.obs.parcsn_esp, ...(n_parcelamentos || [])])];
        }

        if (tipo_s === "4.3") {
          this.obs.pertsn = [...new Set([...this.obs.pertsn, ...(n_parcelamentos || [])])];
        }

        if (tipo_s === "4.4") {
          this.obs.relpsn = [...new Set([...this.obs.relpsn, ...(n_parcelamentos || [])])];
        }

        if (tipo_s === "4.5") {
          this.obs.parcmei = [...new Set([...this.obs.parcmei, ...(n_parcelamentos || [])])];
        }

        if (tipo_s === "4.6") {
          this.obs.parcmei_esp = [...new Set([...this.obs.parcmei_esp, ...(n_parcelamentos || [])])];
        }

        if (tipo_s === "4.7") {
          this.obs.pertmei = [...new Set([...this.obs.pertmei, ...(n_parcelamentos || [])])];
        }

        if (tipo_s === "4.8") {
          this.obs.relpmei  = [...new Set([...this.obs.relpmei , ...(n_parcelamentos || [])])];
        }
      }

      if (tipo_p === 5) {
        this.obs.showSefa = true;
        if (!this.obs.list.includes(tipo_s)) this.obs.list.push(tipo_s);

        if (tipo_s === "5.1") {
          this.obs.sefa_prorefis = [...new Set([...this.obs.sefa_prorefis, ...(n_parcelamentos || [])])];
        }

        if (tipo_s === "5.2") {
          this.obs.sefa_acompanhar = [...new Set([...this.obs.sefa_acompanhar, ...(n_parcelamentos || [])])];
        }
      }

      if (dia_agendamento) this.obs.dia_agendamento = dia_agendamento;

    }
  };

  /**
   * Renderiza um botão para download da **parcela atual** (primeira da lista) associada à linha da tabela.
   * 
   * Esta função:
   * - Recebe como parâmetros:
   *   - `cell`: valor da célula da tabela (não utilizado diretamente).
   *   - `row`: objeto que representa a linha da tabela, contendo a propriedade `parcela` (um array de parcelas).
   * 
   * Regras de funcionamento:
   * - Se `row.parcela` não existir ou for uma lista vazia:
   *    - A função retorna `undefined`, ou seja, **nenhum botão será renderizado**.
   * 
   * - Se houver ao menos uma parcela:
   *    - A primeira parcela (`row.parcela[0]`) é considerada a "parcela atual".
   *    - Verifica-se se:
   *      - A parcela possui `_id` válido.
   *      - O campo `arquivo` está definido como `true`, indicando que há um arquivo disponível para download.
   *    - Se algum desses critérios não for atendido, o botão será **desabilitado** (`disabled = true`).
   * 
   * Ação:
   * - Ao clicar no botão, a função `handleDownloadGuia(parcela)` é chamada, realizando o download da guia correspondente à parcela atual.
   *  
   * @param {any} cell Valor da célula da tabela (não utilizado diretamente).
   * @param {Object} row Linha da tabela contendo a propriedade `parcela` (array de parcelas).
   * @returns {JSX.Element|undefined} Um botão JSX de download ou `undefined` se não houver parcela válida.
  */

  downloadParcelaAtual = (cell, row) => {

    if (!row.parcela || !row.parcela.length) return

    const parcela = row.parcela[0]

    return (
      <MDBBtn
        disabled={!parcela._id || parcela.arquivo !== true}
        color="default"
        rounded
        className="botaoDownload"
        size="sm"
        onClick={(e) => this.handleDownloadGuia(parcela)}
      >
        <AppIcon name={"download"} size={24} color="#2b82bc" />
      </MDBBtn>
    );
  }

  /**
 * Define dinamicamente a classe CSS a ser aplicada a uma linha da tabela,
 * destacando visualmente as linhas cuja parcela possui vencimento no mês atual.
 *
 * Esta função:
 * - Recebe os dados de uma linha (`row`) e verifica, por meio de `isVencimentoDoMesAtual`,
 *   se ela corresponde a uma parcela com vencimento referente ao mês atual.
 * - Retorna a classe `"row-vencimento-mes"` para estilização especial quando a condição for verdadeira.
 * - Caso contrário, retorna uma string vazia, mantendo a linha sem destaque.
 *
 * É utilizada para aplicar estilização condicional em tabelas de parcelamentos, facilitando
 * a identificação das parcelas do mês atual.
 *
 * @param {object} row Objeto com os dados da linha da tabela.
 * @param {number} _rowIndex Índice da linha (não utilizado, mas necessário para compatibilidade com a tabela).
 * @returns {string} A classe CSS a ser aplicada à linha.
 */

  rowClassName = (row: any, _rowIndex: number) => {
    return this.isVencimentoDoMesAtual(row) ? "row-vencimento-mes" : "";
  };

  /**
  * Verifica se a parcela informada possui vencimento no mês atual e se o arquivo correspondente está disponível.
  *
  * Esta função:
  * - Retorna `false` imediatamente caso a linha não possua `data_vencimento` válida
  *   ou se o campo `arquivo` não seja `true` (indicando ausência de arquivo disponível).
  * - Converte a data de vencimento para um objeto `moment` e compara com a data atual.
  * - Considera que o vencimento é do mês atual somente quando:
  *   - o mês é o mesmo do mês atual, **e**
  *   - o ano é o mesmo do ano atual.
  *
  * É utilizada como condição auxiliar para destacar visualmente parcelas do mês atual
  * (por exemplo, com cores ou classes CSS específicas).
  *
  * @param {object} row Objeto contendo os dados da linha, incluindo `data_vencimento` e `arquivo`.
  * @returns {boolean} `true` se a parcela vencer no mês e ano atuais e tiver arquivo disponível; caso contrário, `false`.
  */

  isVencimentoDoMesAtual = (row: any): boolean => {
    if (!row?.data_vencimento || row.arquivo !== true) return false;

    const vencimento = moment(row.data_vencimento);
    const agora = moment();

    return vencimento.isSame(agora, 'month') && vencimento.isSame(agora, 'year');
  };

  handleOpenEmp() {

    cookies.set('__EMP-PARCE', { tab: "sefa", }, { path: '/' });

    window.open(`/empresa/edit/${this.obs.selectEmpresaSolicitacao._id}`, "_blank")

  }

  render() {

    let empresaText = this.obs.selectEmpresa.cnpj != ""
      ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
      : "Selecione uma empresa";

    const getOptionsSubCategoria = () => {

      if (this.obs.tipoParcela == 2) {
        return (<>
          <option value={""}>Todas</option>
          <option value={"2.1"}>Simplificado Previdenciário</option>
          <option value={"2.2"}>Não Previdenciário</option>
        </>)
      }

      if (this.obs.tipoParcela == 3) {
        return (<>
          <option value={""}>Todas</option>
          <option value={"3.1"}>Parcelamento Lei 12.996/2014</option>
          <option value={"3.2"}>Parcelamento Lei 11.941/2009</option>
          <option value={"3.3"}>Previdenciário INSS</option>
          <option value={"3.4"}>Previdenciário PERT</option>
          <option value={"3.5"}>Especiais (Solicitar e Acompanhar)</option>
        </>)
      }

      if (this.obs.tipoParcela == 4) {
        return (<>
          <option value={""}>Todas</option>
          <option value={"4.1"}>Parcelamento do Simples Nacional - Ordinário</option>
          <option value={"4.2"}>Parcelamento do Simples Nacional - Especial</option>
          <option value={"4.3"}>Programa Especial de Regularização Tributária do Simples Nacional</option>
          <option value={"4.4"}>Programa de Reescalonamento do Pagamento de Débitos no Âmbito do Simples Nacional</option>
          <option value={"4.5"}>Parcelamento do Microempreendedor Individual - Ordinário</option>
          <option value={"4.6"}>Parcelamento do Microempreendedor Individual - Especial</option>
          <option value={"4.7"}>Programa Especial de Regularização Tributária do Microempreendedor Individual</option>
          <option value={"4.8"}>Programa de Reescalonamento do Pagamento de Débitos no Âmbito do Microempreendedor Individual</option>
        </>)
      }

    }

    return (
      <>
        <MDBRow>
          <MDBCol md="3">
            <FormGroup className="empresaSelect" label="Empresa">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => this.obs.selectEmpresa = e}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaText}
                  rightIcon={
                    this.obs.selectEmpresa.cnpj ? (
                      <Icon
                        className="clear-icon-empresa"
                        icon="cross"
                        onClick={(ev) => {
                          ev.stopPropagation();
                          this.obs.selectEmpresa = newEmpresa();
                        }}
                      />
                    ) : (
                      <Icon icon="double-caret-vertical" style={{ padding: 5 }} />
                    )
                  }
                  alignText={Alignment.LEFT} />
              </EmpresaSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup label="Situação">
              <HTMLSelect onChange={(e) => this.obs.filter_situacao = e.target.value}
                value={this.obs.filter_situacao}>
                <option value={""}>Todas</option>
                <option value={"Atrasado"}>Atrasado</option>
                <option value={"Em Dia"}>Em dia</option>
                <option value={"Pendente"}>Pendências</option>
                <option value={"Não Encontrado"}>Não encontrado</option>
              </HTMLSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup label="Categoria parcelas">
              <HTMLSelect
                onChange={(e) => {
                  this.obs.tipoSubParcela = ""
                  this.obs.tipoParcela = parseInt(e.target.value)
                }}
                value={this.obs.tipoParcela}
              >
                <option value={0}>Todas</option>
                <option value={1}>PGFN</option>
                <option value={2}>Receita Federal</option>
                <option value={3}>Especiais</option>
                <option value={4}>Simples Nacional</option>
                <option value={5}>SEFA</option>
              </HTMLSelect>
            </FormGroup>
          </MDBCol>

          {[2, 3].includes(this.obs.tipoParcela) &&
            <MDBCol md="2">
              <FormGroup label="Sub-categoria parcelas">
                <HTMLSelect
                  onChange={(e) => this.obs.tipoSubParcela = e.target.value}
                  value={this.obs.tipoSubParcela}
                >
                  {getOptionsSubCategoria()}
                </HTMLSelect>
              </FormGroup>
            </MDBCol>
          }

          <MDBCol md="2">
            <MDBBtn
              className="btnDefault btnBuscarNfe mt25"
              onClick={() => this.handleAtualizaTarefasPaged()}
            >
              Buscar
            </MDBBtn>
          </MDBCol>

        </MDBRow>

        <div className="alert alert-warning" style={{ display: "inherit" }}>
          <AppIcon size={20} name="warning" style={{ marginRight: 10 }} />
          O e-CAC permite apenas 15 sessões por hora quando se utiliza o certificado digital do contator. Para contornar essa limitação, utilize o certificado digital da própria empresa ao criar o Monitoramento.
        </div>

        <MDBRow>
          <MDBCol md="12" className="">
            {/* <MDBBtn
              className="btnDefault btnBuscarNfe"
              style={{ marginRight: 10, float: "left" }}>
              Exportar planilha
            </MDBBtn> */}
            <MDBBtn
              className="btnDefault btnBuscarNfe"
              onClick={(e) => this.handleOpenCreate()}
              style={{ marginRight: 10, float: "right" }}>
              Criar solicitação das parcelas
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <div>
          <BootstrapTable className="TableDefault" ref="table" data={sortBy(ParcelamentosStore.obs.tasks_parcelamentos, "inserted_at").reverse()}>
            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.situacaoTarefa} width="15%">Situação</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.tipoFormat} dataField="tipo_s" width="15%">Tipo</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.cnpjFormatter} width="20%">Empresa</TableHeaderColumn>
            <TableHeaderColumn dataField="dia_agendamento" width="10%" dataAlign="center">Dia agendamento</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.statusFormatter} dataField="situacao" width="30%" dataAlign="center">Status tarefa</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.dateFormatter} dataField="_modifiedTS" width="10%">Ultima Atualização</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.viewErros} dataAlign="center" width="5%">Erros</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.editParcelamento} dataAlign="center" width="5%">Editar</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.viewParcelamentos} dataAlign="center" width="5%">Histórico</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.tarefas_page}
            totalCount={ParcelamentosStore.obs.tasks_length}
            pageSize={15}
            onPageChange={page => this.handleBuscaTarefasPaged(page)} />
        </div>

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.view_parcelamentos}
          onConfirm={() => this.onCloseErros()}
          onClose={() => this.onCloseErros()}
          canOutsideClickCancel={true}
          className="AlertUser"
          intent="primary"
        >
          <h3 className="titleProccess titleCnae">Logs Erros</h3>
          <br />
          <p>{this.obs.erros}</p>
        </Alert>

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.view_parcelas}
          onConfirm={() => this.onCloseErros()}
          onClose={() => this.onCloseErros()}
          canOutsideClickCancel={true}
          className="AlertUser"
          intent="primary"
        >
          <h3 className="titleProccess titleCnae">Logs Erros</h3>
          <br />
          <p>{this.obs.erros}</p>
        </Alert>

        <Dialog
          isOpen={ParcelamentosStore.obs.open_solicitar}
          onClose={() => ParcelamentosStore.obs.open_solicitar = false}
        >
          <h2 className="titleSEFAZ" style={{ marginBottom: 5 }}>Solicitações parcelas</h2>
          <div className="alert alert-warning" style={{ display: "inherit" }}>
            <AppIcon size={20} name="warning" style={{ marginRight: 10 }} />
            Para garantir que não ocorram vencimentos indevidos, é permitido agendar somente até o dia 25. <br />
          </div>
          <MDBRow>
            <MDBCol md="8">
              <FormGroup className="empresaSelect" label="Empresa" labelInfo={<div style={{ marginBottom: 2 }} />}>
                <EmpresaSelect
                  items={EmpresaStore.sortedEmpresas}
                  itemRenderer={renderEmpresa}
                  itemPredicate={filterEmpresa}
                  onItemSelect={(e: IEmpresa) => this.handleSelecionaEmpresaSolicitacao(e)}
                >
                  <Button
                    text={
                      this.obs.selectEmpresaSolicitacao.cnpj
                        ? `${this.obs.selectEmpresaSolicitacao.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresaSolicitacao.cnpj)})`
                        : "Selecione uma empresa"
                    }
                    alignText={Alignment.LEFT}
                    rightIcon={
                      this.obs.selectEmpresaSolicitacao.cnpj ? (
                        <Icon
                          className="clear-icon-empresa"
                          icon="cross"
                          onClick={(ev) => {
                            ev.stopPropagation();
                            this.handleSelecionaEmpresaSolicitacao(newEmpresa());
                          }}
                        />
                      ) : (
                        <Icon icon="double-caret-vertical" style={{ padding: 5 }} />
                      )
                    }
                  />
                </EmpresaSelect>
              </FormGroup>
            </MDBCol>

            <MDBCol md="4">
              <FormGroup label="Todo dia:" className="inputsDiaSolicitacaoParcela" labelInfo={<>
                &nbsp;<AppIcon name="help" className="pulse-notification-pgdas" color="blue" size={20} style={{ cursor: "pointer" }} onClick={() => this.obs.open_ajuda = true} />
              </>
              }>
                <HTMLSelect
                  value={this.obs.dia_agendamento}
                  onChange={(e) => { this.obs.dia_agendamento = Number(e.target.value) }}
                >
                  {this.handleDays()}
                </HTMLSelect>
              </FormGroup>
            </MDBCol>

          </MDBRow>
          <div style={{ overflow: "auto", maxHeight: 400, paddingRight: 10 }}>

            <Switch
              label="PGFN"
              alignIndicator="right"
              checked={this.obs.showPGFN}
              disabled={!this.obs.selectEmpresaSolicitacao?.cnpj}
              onChange={(e: any) => this.obs.showPGFN = e.target.checked}
              style={{ width: "max-content", fontWeight: "bold" }}
            />

            {this.obs.showPGFN && (
              <div style={{ marginBottom: 10 }}>
                <PagamentosMultiselect onChange={(selected) =>
                  this.obs.pgfn = selected} value={this.obs.pgfn} />
              </div>
            )}

            <Switch
              label="Receita Federal"
              alignIndicator="right"
              checked={this.obs.showReceita}
              disabled={!this.obs.selectEmpresaSolicitacao?.cnpj}
              onChange={(e: any) => this.obs.showReceita = e.target.checked}
              style={{ width: "max-content", fontWeight: "bold" }}
            />

            {this.obs.showReceita && (
              <div>
                <label className="label-align">
                  <input type="checkbox" onChange={() => this.handleCheckChange("2.1")} checked={this.obs.list.includes("2.1")} />
                  &nbsp;
                  Simplificado
                </label><br />
                {this.obs.list.includes("2.1") && (
                  <div style={{ marginBottom: 10 }}><PagamentosMultiselect
                    onChange={(selected) => this.obs.itens_simplificado = selected}
                    value={this.obs.itens_simplificado}
                  />
                  </div>
                )}

                <label className="label-align">
                  <input type="checkbox" onChange={() => this.handleCheckChange("2.2")} checked={this.obs.list.includes("2.2")} />
                  &nbsp;
                  Não Previdenciário
                </label><br />
                {this.obs.list.includes("2.2") && (
                  <div style={{ marginBottom: 10 }}><PagamentosMultiselect
                    onChange={(selected) => this.obs.itens_nao_previdenciario = selected}
                    value={this.obs.itens_nao_previdenciario}
                  />
                  </div>
                )}
              </div>
            )}

            <Switch
              label="Especiais"
              alignIndicator="right"
              checked={this.obs.showEspeciais}
              disabled={!this.obs.selectEmpresaSolicitacao?.cnpj}
              onChange={(e: any) => this.obs.showEspeciais = e.target.checked}
              style={{ width: "max-content", fontWeight: "bold" }}
            />

            {this.obs.showEspeciais && (
              <div style={{ marginBottom: 10 }}>
                <label className="label-align">
                  <input type="checkbox" onChange={() => this.handleCheckChange("3.1")} checked={this.obs.list.includes("3.1")} />
                  &nbsp;
                  Parcelamento Lei 12.996/2014
                </label><br />

                <label className="label-align tooltip-container">
                  <input type="checkbox" onChange={() => this.handleCheckChange('3.2')} checked={this.obs.list.includes('3.2')} disabled />
                  &nbsp;
                  Parcelamento Lei 11.941/2009
                  <span className="tooltip-text">
                    Caso você possua uma empresa com esse parcelamento favor entrar em contato com o suporte.
                  </span>
                </label><br />
                {this.obs.list.includes("3.2") && (
                  <div style={{ marginBottom: 10 }}><PagamentosMultiselect
                    onChange={(selected) => this.obs.lei_11941 = selected}
                    value={this.obs.lei_11941}
                  />
                  </div>
                )}

                <label className="label-align tooltip-container">
                  <input type="checkbox" onChange={() => this.handleCheckChange('3.3')} checked={this.obs.list.includes('3.3')} disabled />
                  &nbsp;
                  Previdenciário INSS
                  <span className="tooltip-text">
                    Caso você possua uma empresa com esse parcelamento favor entrar em contato com o suporte.
                  </span>
                </label>
                <br />
                {this.obs.list.includes("3.3") && (
                  <div style={{ marginBottom: 10 }}><PagamentosMultiselect
                    onChange={(selected) => this.obs.previdenciario_inss = selected}
                    value={this.obs.previdenciario_inss}
                  />
                  </div>
                )}

                <label className="label-align">
                  <input type="checkbox" onChange={() => this.handleCheckChange("3.4")} checked={this.obs.list.includes("3.4")} />
                  &nbsp;
                  Previdenciário PERT
                </label><br />
                {this.obs.list.includes("3.4") && (
                  <div style={{ marginBottom: 10 }}><PagamentosMultiselect
                    onChange={(selected) => this.obs.previdenciario_pert = selected}
                    value={this.obs.previdenciario_pert}
                  />
                  </div>
                )}

                <label className="label-align">
                  <input type="checkbox" onChange={() => this.handleCheckChange("3.5")} checked={this.obs.list.includes("3.5")} />
                  &nbsp;
                  Especiais (Solicitar e Acompanhar)
                </label><br />
                {this.obs.list.includes("3.5") && (
                  <div style={{ marginBottom: 10 }}><PagamentosMultiselect
                    onChange={(selected) => this.obs.especiais = selected}
                    value={this.obs.especiais}
                  />
                  </div>
                )}
              </div>
            )}

            <Switch
              label="Simples Nacional"
              alignIndicator="right"
              checked={this.obs.showSimples}
              disabled={!this.obs.selectEmpresaSolicitacao?.cnpj && !(this.obs.selectEmpresaSolicitacao?.uf === "PA")}
              onChange={(e: any) => this.obs.showSimples = e.target.checked}
              style={{ width: "max-content", fontWeight: "bold" }}
            />

            {this.obs.showSimples && (
              <div>
                <label className="label-align">
                  <input type="checkbox" onChange={() => this.handleCheckChange("4.1")} checked={this.obs.list.includes("4.1")} />
                  &nbsp;
                  Parcelamento do Simples Nacional - Ordinário
                </label><br />

                <label className="label-align">
                  <input type="checkbox" onChange={() => this.handleCheckChange("4.2")} checked={this.obs.list.includes("4.2")} />
                  &nbsp;
                  Parcelamento do Simples Nacional - Especial
                </label><br />

                <label className="label-align">
                  <input type="checkbox" onChange={() => this.handleCheckChange("4.3")} checked={this.obs.list.includes("4.3")} />
                  &nbsp;
                  Programa Especial de Regularização Tributária do Simples Nacional
                </label><br />

                <label className="label-align">
                  <input type="checkbox" onChange={() => this.handleCheckChange("4.4")} checked={this.obs.list.includes("4.4")} />
                  &nbsp;
                  Programa de Reescalonamento do Pagamento de Débitos no Âmbito do Simples Nacional
                </label><br />

                <label className="label-align">
                  <input type="checkbox" onChange={() => this.handleCheckChange("4.5")} checked={this.obs.list.includes("4.5")} />
                  &nbsp;
                  Parcelamento do Microempreendedor Individual - Ordinário
                </label><br />

                <label className="label-align">
                  <input type="checkbox" onChange={() => this.handleCheckChange("4.6")} checked={this.obs.list.includes("4.6")} />
                  &nbsp;
                  Parcelamento do Microempreendedor Individual - Especial
                </label><br />

                <label className="label-align">
                  <input type="checkbox" onChange={() => this.handleCheckChange("4.7")} checked={this.obs.list.includes("4.7")} />
                  &nbsp;
                  Programa Especial de Regularização Tributária do Microempreendedor Individual
                </label><br />

                <label className="label-align">
                  <input type="checkbox" onChange={() => this.handleCheckChange("4.8")} checked={this.obs.list.includes("4.8")} />
                  &nbsp;
                  Programa de Reescalonamento do Pagamento de Débitos no Âmbito do Microempreendedor Individual
                </label><br />

              </div>
            )}

            <Switch
              label="SEFA"
              alignIndicator="right"
              checked={this.obs.showSefa}
              disabled={!this.obs.selectEmpresaSolicitacao?.cnpj && !(this.obs.selectEmpresaSolicitacao?.uf === "PA")}
              onChange={(e: any) => this.obs.showSefa = e.target.checked}
              style={{ width: "max-content", fontWeight: "bold" }}
            />

            {this.obs.showSefa && (
              <div>
                <label className="label-align">
                  <input type="checkbox" onChange={() => this.handleCheckChange("5.1")} checked={this.obs.list.includes("5.1")} />
                  &nbsp;
                  PROREFIS
                </label><br />
                {this.obs.list.includes("5.1") && (
                  <div style={{ marginBottom: 10 }}>
                    <PagamentosMultiselect
                      onChange={(selected) => this.obs.sefa_prorefis = selected}
                      value={this.obs.sefa_prorefis}
                    />
                  </div>
                )}

                <label className="label-align">
                  <input type="checkbox" onChange={() => this.handleCheckChange("5.2")} checked={this.obs.list.includes("5.2")} />
                  &nbsp;
                  Acompanhar
                </label><br />
                {this.obs.list.includes("5.2") && (
                  <div style={{ marginBottom: 10 }}>
                    <PagamentosMultiselect
                      onChange={(selected) => this.obs.sefa_acompanhar = selected}
                      value={this.obs.sefa_acompanhar}
                    />
                  </div>
                )}
              </div>
            )}

            <button
              disabled={!this.obs.selectEmpresaSolicitacao?.cnpj}
              onClick={() => this.handleOpenEmp()}
              style={{ padding: 0, border: "none", background: "none", fontWeight: "bold", textDecoration: "underline", color: "#3579ea", textAlign: "left", width: "max-content" }}
            >
              {"Acessar configurações adicionais do parcelamento (e-CAC, SEFA e ARQUIVOS)"}
            </button>

          </div>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              text="Fechar"
              onClick={() => {
                this.resetSolicitacaoModal()
                ParcelamentosStore.obs.open_solicitar = false
              }}
            />
            <Button
              text="Solicitar"
              intent="primary"
              onClick={() => this.handleConcluirSolicitacao()}
            />
          </div>

        </Dialog>

        {/* Histórico parcelas */}

        <Dialog
          isOpen={ParcelamentosStore.obs.open_parcelas}
          onClose={() => ParcelamentosStore.obs.open_parcelas = false}
          className="AlertUser"
        >
          <h2 className="titleSEFAZ">Histórico parcelas {this.tributoFormatter(this.obs.tributo, "")}</h2>
          <div className="bloco-emp-erro" style={{ display: "flex", padding: 15 }}>
            <div style={{ width: 50 }}>
              <AppIcon name={"apartment"} size={30} color="#2b82bc" style={{ marginTop: 10 }} />
            </div>
            <div>
              <span>{this.getRazao(this.obs.edit_row.cnpj)}</span>
              <br />
              <br />
              <span>{formatCnpj(this.obs.edit_row.cnpj)}</span>
            </div>

          </div>
          <MDBRow>
            <FormGroup label="Período" style={{ marginLeft: 15, width: 200 }}>
              <LocalizationProvider
                localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                adapterLocale={"pt-br"}
                dateAdapter={AdapterDayjs}>
                <DatePicker value={ParcelamentosStore.obs.dataEntrada} className="input-data-apuracao" views={['month', 'year']} onChange={(value) => this.handlePeriodo(value)} format="MM/YYYY" slotProps={{ textField: { size: 'small' } }} />
              </LocalizationProvider>
            </FormGroup>

            <FormGroup label="Situação parcela" style={{ width: 220, marginLeft: 15 }}>
              <HTMLSelect
                onChange={(e) => this.handleChangeFilterStatusParcelas(e.target.value)}
                value={this.obs.filter_status_parcelas}
                style={{ width: 220 }}
              >
                <option value="">Todos</option>
                <option value="Pendente">Pendente</option>
                <option value="Pago">Pago</option>
                <option value="Vencida">Vencida</option>
                <option value="Cancelada">Cancelada</option>
              </HTMLSelect>
            </FormGroup>
          </MDBRow>
          <p style={{ color: "#c15151" }}><b> Obs: Ficará destacada a parcela que tiver o arquivo disponível e cujo vencimento seja referente ao mês atual. </b></p>
          <div style={{ overflow: "auto", maxHeight: 600 }}>

            <div>
              <BootstrapTable className="" ref="table" data={ParcelamentosStore.obs.parcelas} trClassName={this.rowClassName}>
                <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                <TableHeaderColumn dataField={"n_parcela"} width="5%">Parcela</TableHeaderColumn>
                <TableHeaderColumn dataFormat={this.dateFormatter} dataField={"data_vencimento"} width="10%">Data de Vencimento</TableHeaderColumn>
                <TableHeaderColumn dataFormat={this.valorFormatter} dataField={"saldo_devedor"} width="10%">Valor</TableHeaderColumn>
                <TableHeaderColumn dataFormat={this.situacaoParcela} dataField={"situacao"} width="15%">Situação</TableHeaderColumn>
                <TableHeaderColumn dataFormat={this.dateFormatter} dataField="_modifiedTS" width="10%">Ultima Atualização</TableHeaderColumn>
                <TableHeaderColumn dataFormat={this.downloadParcela} dataAlign="center" width="5%">Baixar guia</TableHeaderColumn>
              </BootstrapTable>
            </div>

          </div>

          <div style={{ width: "100%" }}>
            <Button text="Fechar" onClick={() => this.handleCloseParcelasModal()} style={{ marginTop: "30px", float: "left" }} />
            <div style={{ marginTop: 5, float: "right" }}>
              <Pager
                currentPage={this.obs.parcelas_page}
                totalCount={ParcelamentosStore.obs.parcelas_length}
                pageSize={5}
                onPageChange={page => this.handleBuscaParcelasPaged(page)} />
            </div>
          </div>

        </Dialog>

        {/* Histórico parcelamentos */}

        <Dialog
          isOpen={ParcelamentosStore.obs.open_parcelamentos}
          onClose={() => ParcelamentosStore.obs.open_parcelamentos = false}
          className="AlertUser"
        >
          <h2 className="titleSEFAZ">Histórico parcelamentos</h2>
          <div className="bloco-emp-erro" style={{ display: "flex", padding: 15 }}>
            <div style={{ width: 50 }}>
              <AppIcon name={"apartment"} size={30} color="#2b82bc" style={{ marginTop: 10 }} />
            </div>
            <div>
              <span>{this.getRazao(this.obs.edit_row.cnpj)}</span>
              <br />
              <br />
              <span>{formatCnpj(this.obs.edit_row.cnpj)}</span>
            </div>

          </div>
          <MDBRow>
            <FormGroup label="Referência" style={{ marginLeft: 15, width: 300 }}>
              <InputGroup placeholder="Filtrar Referência" value={this.obs.filter_referencia} onChange={(e) => this.handleChangeFilterParcelamentos(e.target.value)} />
            </FormGroup>

            <FormGroup label="Situação parcelamento" style={{ width: 220, marginLeft: 15 }}>
              <HTMLSelect onChange={(e) => this.handleChangeFilterSituacaoParcelamentos(e.target.value)} value={this.obs.filter_status} style={{ width: 220 }}>
                <option value="">Todos</option>
                <option value="Atrasado">Atrasado</option>
                <option value="Encerrado">Encerrado</option>
                <option value="Pendente">Pendente</option>
              </HTMLSelect>
            </FormGroup>
          </MDBRow>

          <div style={{ overflow: "auto", maxHeight: 600 }}>

            <div>
              <BootstrapTable className="" ref="table" data={sortBy(ParcelamentosStore.obs.parcelamentos, "_insertedTS").reverse()}>
                <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                <TableHeaderColumn dataField={"n_parcelamento"} width="10%">Referência</TableHeaderColumn>
                <TableHeaderColumn dataFormat={this.tributoFormatter} dataField="tributo" width="10%">Tributo</TableHeaderColumn>
                <TableHeaderColumn dataFormat={this.situacaoParcelamento} width="15%">Situação</TableHeaderColumn>
                <TableHeaderColumn dataFormat={this.dateFormatter} dataField="_modifiedTS" width="10%">Ultima Atualização</TableHeaderColumn>
                <TableHeaderColumn dataFormat={this.viewParcelas} dataAlign="center" width="5%">Ver guias</TableHeaderColumn>
                <TableHeaderColumn dataFormat={this.downloadParcelaAtual} dataAlign="center" width="5%">Baixar guia</TableHeaderColumn>
              </BootstrapTable>
            </div>
          </div>

          <div style={{ width: "100%" }}>
            <Button text="Fechar" onClick={() => ParcelamentosStore.obs.open_parcelamentos = false} style={{ marginTop: "30px", float: "left" }} />
            <div style={{ marginTop: 5, float: "right" }}>
              <Pager
                currentPage={this.obs.parcelamentos_page}
                totalCount={ParcelamentosStore.obs.parcelamentos_length}
                pageSize={5}
                onPageChange={page => this.handleBuscaParcelamentosPaged(page)} />
            </div>
          </div>

        </Dialog>

        {/* EDIÇÃO */}

        <Dialog
          isOpen={this.obs.open_edit_task_parcelamento}
          onClose={() => this.handleCloseEditTarefa()}
          className="modal-cnds"
        >
          <h2 className="titleSEFAZ">Editar Agendamento {this.tipoFormat(this.obs.edit_row.tipo_s)}</h2>
          <div className="bloco-emp-erro" style={{ display: "flex", padding: 15 }}>
            <div style={{ width: 50 }}>
              <AppIcon name={"apartment"} size={30} color="#2b82bc" style={{ marginTop: 10 }} />
            </div>
            <div>
              <span>{this.getRazao(this.obs.edit_row.cnpj)}</span>
              <br />
              <br />
              <span>{formatCnpj(this.obs.edit_row.cnpj)}</span>
            </div>
          </div>

          <FormGroup label="Todo dia:" style={{ width: 75 }}>
            <HTMLSelect
              value={this.obs.edit_row.dia_agendamento || 10}
              onChange={(e) => this.obs.edit_row.dia_agendamento = Number(e.target.value)}
              className="inputsDiaSolicitacaoParcela"
            >
              {this.handleDays()}
            </HTMLSelect>
          </FormGroup>
          <FormGroup label="Nº Parcelamentos">
            <div style={{ marginBottom: 10 }}>
              <PagamentosMultiselect
                onChange={(selected) => this.obs.edit_row.n_parcelamentos = selected}
                value={this.obs.edit_row.n_parcelamentos}
                disabled={this.tiposBloquearNumeroEdicao.includes(this.obs.edit_row.tipo_s)}
              />
            </div>
          </FormGroup>
          <Switch
            label="Ativo"
            alignIndicator="right"
            checked={this.obs.edit_row.ativo}
            onChange={(e: any) => this.obs.edit_row.ativo = e.target.checked}
            style={{ width: "max-content", fontWeight: "bold" }}
          />
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" onClick={() => this.handleCloseEditTarefa()} />
            <Button text="Salvar" intent="primary" onClick={() => this.handleUpdateTask()} />
          </div>
        </Dialog>

        <LoadingModal open={ParcelamentosStore.obs.loading_arquivos} onClose={() => ParcelamentosStore.obs.loading_arquivos = false} title={"Baixando arquivo"} />
        <LoadingModal open={ParcelamentosStore.obs.loading_tasks} onClose={() => ParcelamentosStore.obs.loading_tasks = false} title={"Buscando solicitações"} />
        <LoadingModal open={ParcelamentosStore.obs.loading_parcelamentos} onClose={() => ParcelamentosStore.obs.loading_parcelamentos = false} title={"Buscando parcelamentos"} />
        <LoadingModal open={ParcelamentosStore.obs.loading_parcelas} onClose={() => ParcelamentosStore.obs.loading_parcelas = false} title={"Buscando parcelas"} />

        <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info={`
        
          <p>Campo referente ao agendamento mensal para download das DARFs.</p>
          <br>
          Selecione o dia do mês em que deseja que o sistema realize automaticamente o download das DARFs.
          Essa operação será executada mensalmente no dia escolhido.
          <br><br>

          <b>Importante:</b> Caso escolhido o dia menor que o dia atual será apenas realizado o download das DARFs no próximo mês!<br /><br />

        `} />

      </>
    )
  }
}
